// Mock the map data
const mapData = [
  {
    name: 'Jawa Barat',
    id: 'JB',
    type: 'province',
    coordinate: {
      lat: -6.918100,
      lng: 107.619122
    },
    link: '/program',
    total: 25,
    markerType: 'program',
    metadata: [
      {
        name: 'Ongoing Program',
        count: 10,
        link: '/programs'
      },
      {
        name: 'Completed Program',
        count: 15,
        link: '/programs'
      },
    ],
    places: [
      {
        name: 'Bandung',
        id: 'bandung',
        type: 'city',
        coordinate: {
          lat: -6.918100,
          lng: 107.619122,
        },
        total: 12,
        markerType: 'program',
        metadata: [
          {
            name: 'Ongoing Program',
            count: 5,
            link: '/programs'
          },
          {
            name: 'Completed Program',
            count: 7,
            link: '/programs'
          },
        ],
        places: [
          {
            name: 'Program Bandung 1',
            id: 'program-bandung-1',
            type: 'headquarter',
            markerType: 'completed_program',
            coordinate: {
              lat: -6.945979,
              lng: 107.626622,
            },
            content: '<p>Eu eiusmod eiusmod duis magna cupidatat consequat labore dolor do incididunt pariatur.</p>',
            link: '/program/1/detail'
          },
          {
            name: 'Program Bandung 2',
            id: 'program-bandung-2',
            type: 'place',
            coordinate: {
              lat: -6.921579,
              lng: 107.607319,
            },
            markerType: 'ongoing_program',
            content: 'Do proident est reprehenderit ut ex velit ex tempor aliqua est sint voluptate nisi.'
          }
        ]
      },
      {
        name: 'Sukabumi',
        id: 'sukabumi',
        type: 'city',
        coordinate: {
          lat: -6.927981,
          lng: 106.928982
        },
        total: 2,
        markerType: 'ongoing_program',
        metadata: [
          {
            name: 'Ongoing Program',
            count: 2
          }
        ],
        places: [
          {
            name: 'Ongoing Program 1',
            id: 'ongoing-program-1',
            type: 'headquarter',
            coordinate: {
              lat: -6.949282,
              lng: 106.928296
            },
            markerType: 'ongoing_program',
            content: 'Voluptate aute mollit exercitation velit pariatur veniam veniam officia. ',
            link: '/program/1/detail'
          },
          {
            name: 'ongoing Program 2',
            id: 'ongoing-program-2',
            type: 'headquarter',
            coordinate: {
              lat: -6.957120,
              lng: 106.907868
            },
            markerType: 'ongoing_program',
            content: 'Excepteur cupidatat aliquip et consectetur quis commodo laboris reprehenderit officia in enim veniam nulla.',
            link: '/program/1/detail'
          }
        ]
      },
      {
        name: 'Cirebon',
        id: 'cirebon',
        type: 'city',
        coordinate: {
          lat: -6.728371,
          lng: 108.553008
        },
        total: 2,
        markerType: 'completed_program',
        metadata: [
          {
            name: 'Completed Program',
            count: 2
          }
        ],
        places: [
          {
            name: 'Ongoing Program Cirebon',
            id: 'ongoing-program-cirebon',
            type: 'headquarters',
            coordinate: {
              lat: -6.778319,
              lng: 108.541164,
            },
            markerType: 'ongoing_program',
            content: 'Tempor velit officia cillum Lorem eu aute culpa est nulla. ',
            link: '/program/1/detail'
          },
          {
            name: 'Completed Adispiscing',
            id: 'completed-adispiscing',
            type: 'headquarters',
            coordinate: {
              lat: -6.699885,
              lng: 108.554966,
            },
            markerType: 'completed_program',
            content: 'Sunt consectetur officia pariatur nulla sit non non pariatur dolore. Incididunt culpa nisi enim mollit.',
            link: '/program/1/detail'
          }
        ]
      }
    ]
  },
  {
    name: 'Jawa Timur',
    id: 'JT',
    type: 'province',
    coordinate: {
      lat: -7.257537,
      lng: 112.751971,
    },
    total: 5,
    markerType: 'ongoing_program',
    metadata: [
      {
        name: 'Ongoing Program',
        count: 5,
        link: '/program'
      },
    ],
    places: [
      {
        name: 'Malang',
        id: 'malang',
        type: 'city',
        coordinate: {
          lat: -7.973199,
          lng: 112.628347
        },
        total: 1,
        markerType: 'ongoing_program',
        link: '/program',
        metadata: [
          {
            name: 'Ongoing Program',
            count: 1,
          }
        ],
        places: [
          {
            name: 'Program Malang Sample',
            id: 'program-malang-sample',
            type: 'headquarter',
            markerType: 'ongoing_program',
            coordinate: {
              lat: -7.931037,
              lng: 112.638990,
            },
            link: '/program/1/detail'
          }
        ]
      },
      {
        name: 'Jember',
        id: 'jember',
        type: 'city',
        coordinate: {
          lat: -8.173100,
          lng: 113.701819
        },
        total: 1,
        markerType: 'ongoing_program',
        metadata: [
          {
            name: 'Ongoing Program',
            count: 1,
          }
        ],
        places: [
          {
            name: 'Program Malang Sample 1',
            id: 'program-malang-sample-1',
            type: 'headquarter',
            markerType: 'ongoing_program',
            coordinate: {
              lat: -8.459828,
              lng: 113.689120,
            },
            link: '/program/1/detail'
          }
        ]
      }
    ]
  }
]

export default mapData
